import {CorrespondantDto, IAuditWebServiceClient, INotificationsCommonWebServiceClient} from "@resources/resources";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Component} from "@angular/core";
import {CerbaCookieService, CorrespondantStore, UserStore, PopinCompteComponent, ProfilValideDto} from "@digicerba/common";
import {DetailExamenPageComponent} from "./pages/detail-examen/detail-examen.component";
import {TranslateService} from "@ngx-translate/core";
import { AsiDialogService } from "@asi-ngtools/lib";

@Component({
  selector: 'cerba',
  templateUrl: './cerba.component.html',
  host: {'class': 'flex'}
})
export class CerbaPageComponent {

  context: any;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private correspondantStore: CorrespondantStore,
              private auditWebServiceClient: IAuditWebServiceClient,
              private cookieService: CerbaCookieService,
              private userStore: UserStore,
              private notificationService: INotificationsCommonWebServiceClient,
              private translate: TranslateService,
              public asiDialogService: AsiDialogService) {





    let result;
    this.activatedRoute.queryParams.subscribe(params => {
      console.log(params);
    });
  }

  ngOnInit() {
    let tags: string[] = [];
    if (this.correspondantStore.getCorrespondant()) {
      tags = this.correspondantStore.getCorrespondant().tags;

      if (tags.indexOf("en") != -1 && tags.indexOf("fr") == -1) {
        this.translate.use('en');
      } else if (tags.indexOf("fr") != -1 || tags.indexOf("fra") != -1) {
        this.translate.use('fr');
      } else {
        this.redirectToAccueil();
      }
    } else {
      this.redirectToAccueil();
    }

    let profilValideDto: ProfilValideDto = this.activatedRoute.snapshot.data['profilValide'];

    this.context = {
      user: this.userStore.getUser(),
      domain: this.cookieService.getDomain(window.location.hostname),
      supportBaseUrl: this.cookieService.getSupportBaseUrl(window.location.hostname),
      nbAlerts: this.activatedRoute.snapshot.data['nbAlerts'],
      // Ajout des tags pour la gestion dynamique des outils du header et footer
      tags: tags,
      // Ajout de la gestion de la validité des informations utilisateurs
      profilValide: profilValideDto,
      openPopin: this.openPopinCompte,
      component: this,
    };

    if(profilValideDto.autoDisplayPopin){
      this.openPopinCompte(this);
    }
  }

  openPopinCompte(component: CerbaPageComponent): void{
    let asiDialog = component.asiDialogService.fromComponent(PopinCompteComponent, null);
    let profilValideDto: ProfilValideDto = component.activatedRoute.snapshot.data['profilValide'];
    asiDialog.getComponent().formattedDate = profilValideDto.dateLimite;
  }


  /**
   * Contrôle si on va sur la page de détail d'un examen
   * Si c'est le cas alors on ne doit pas afficher le header et le footer
   * de la page (fonction appelée dans un ngIf pour les afficher/masquer)
   *
   * @returns {boolean} true si on est sur la page de détail, false sinon
   * ==================================================================== */
  checkIfPageDetail(): boolean {
    // PREMIERE VERSION : on teste l'url appelée pour voir si on est sur le détail
    // Inconvénient : si l'url devait changer il faudrait modifier le code
    //let regex = RegExp('/cerba/detail-examen/[0-9]+');
    //return regex.test(this.router.url);

    // DEUXIEME VERSION : on teste si le composant appelé est celui du détail
    // On récupère le composant appelé
    let componentCalled = this.activatedRoute.firstChild.component;

    // Avant de pouvoir tester si le composant appelé est le bon il
    // faut vérifier que son type nous permette bien de faire la vérif
    if (typeof componentCalled === "function"
      && componentCalled.name === DetailExamenPageComponent.name) {
      return true;
    }
    return false;
  }


  checkIFrame() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  redirectToAccueil() {
    let domain = this.getDomain(window.location.hostname);
    window.location.href = window.location.protocol + '//www.' + domain;
  }

  getDomain(sN) {
    let serverName = sN;
    let serverPaths = serverName.split('.');
    let parts = serverPaths.length;
    if (parts > 1) {
      serverName = serverPaths[parts - 2] + "." + serverPaths[parts - 1];
    }
    return serverName;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/cerba.component.ts